export const parseSchoolId = (schoolId: number | undefined) => {
  if (schoolId === undefined) {
    return -1;
  }
  return schoolId;
};



// WEBPACK FOOTER //
// ./src/pages/director/seasons/seasonsPage/utils/parseSchoolId/parseSchoolId.ts